if (!customElements.get("promotional-products-scrollbar")) {
  customElements.define(
    "promotional-products-scrollbar",
    class PromotionalProductsScrollbar extends HTMLElement {
      constructor() {
        super();

        this.mediaQuery = window.matchMedia("(max-width: 989px)");
        this.onScroll = this.update.bind(this);
        this.onResize = this.queueUpdate.bind(this);
        this.frame = null;
      }

      connectedCallback() {
        this.scroller = this.querySelector(".rec_item_wrapper");
        this.track = this.querySelector(".rec_item_scrollbar");
        this.thumb = this.track && this.track.querySelector("span");

        if (!this.scroller || !this.track || !this.thumb) return;

        this.scroller.addEventListener("scroll", this.onScroll, { passive: true });
        window.addEventListener("resize", this.onResize);
        this.mediaQuery.addEventListener("change", this.onResize);

        if (window.ResizeObserver) {
          this.resizeObserver = new ResizeObserver(this.onResize);
          this.resizeObserver.observe(this);
          this.resizeObserver.observe(this.scroller);
        }

        this.queueUpdate();
      }

      disconnectedCallback() {
        if (this.scroller) {
          this.scroller.removeEventListener("scroll", this.onScroll);
        }

        window.removeEventListener("resize", this.onResize);
        this.mediaQuery.removeEventListener("change", this.onResize);

        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
        }

        if (this.frame) {
          window.cancelAnimationFrame(this.frame);
        }
      }

      queueUpdate() {
        if (this.frame) return;

        this.frame = window.requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      }

      update() {
        if (!this.scroller || !this.track || !this.thumb) return;

        if (!this.mediaQuery.matches) {
          this.track.hidden = true;
          return;
        }

        const scrollableWidth = this.scroller.scrollWidth - this.scroller.clientWidth;
        this.track.hidden = scrollableWidth <= 1;

        if (this.track.hidden) return;

        const thumbWidth = Math.max((this.scroller.clientWidth / this.scroller.scrollWidth) * 100, 18);
        const thumbLeft = (this.scroller.scrollLeft / scrollableWidth) * (100 - thumbWidth);

        this.thumb.style.width = `${thumbWidth}%`;
        this.thumb.style.left = `${thumbLeft}%`;
      }
    },
  );
}
